<template>
    <v-layout row justify-center>
        <v-dialog v-model="settings.visible" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="settings.visible = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('inputs.confirmPassengerDialog.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-stepper v-model="step">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">{{ $t('inputs.confirmPassengerDialog.personalInfo') }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2">{{ $t('inputs.confirmPassengerDialog.finish') }}</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <personal-info ref="personal_info" @next_step="next()"></personal-info>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <summary-info ref="summary_info" @next_step="next()"
                                          provider="passenger"
                                          :id="settings.passenger_id"></summary-info>
                        </v-stepper-content>
                        <p class="text-xs-right">
                            <v-btn :disabled="step === 1" @click="step--">{{ $t('inputs.confirmPassengerDialog.last') }}</v-btn>
                            <v-btn :color="step === 2 ? 'primary' : ''" @click="submit">{{step < 2 ? $t('inputs.confirmPassengerDialog.approveAndSave')
                                : $t('inputs.confirmPassengerDialog.approvePassenger')}}
                            </v-btn>
                        </p>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import PersonalInfo from "@/components/confirmation_passenger_components/PersonalInfo";
    import SummaryInfo from "@/components/confirmation_captain_components/SummaryInfo";

    export default {
        name: 'ConfirmPassengerDialog',
        components: {SummaryInfo, PersonalInfo, LoadingComponent},
        props: {
            settings: {
                type: Object,
                default: () => ({
                    visible: false,
                    passenger_id: null
                })
            }
        },
        watch: {
            settings: {
                handler(val) {
                    if (val.visible) {
                        this.step = 1;
                        this.init(this.step);
                    }
                },
                deep: true
            }
        },
        data() {
            return {
                step: 1,
                ref_map: {
                    1: 'personal_info',
                    2: 'summary_info'
                }
            }
        },
        methods: {
            init(cnt) {
                this.$refs[this.ref_map[cnt]].reset();
                this.$refs[this.ref_map[cnt]].update(this.settings.passenger_id);
            },
            submit() {
                this.$refs[this.ref_map[this.step]].submit(this.settings.passenger_id);
            },
            next() {
                if (this.step < 2) {
                    this.init(this.step + 1);
                } else {
                    this.settings.visible = false;
                    this.$emit('approved', this.settings.passenger_id);
                }
                (this.step + 1) > 2 ? this.step = 1 : this.step++;
            }
        }
    }
</script>